import { cn } from 'helpers/classnames';

export const containerClasses = cn(
  'flex flex-wrap gap-x-6 gap-y-3',
  // Lumon styles
  'lumon:ml-2 lumon:md:-ml-2.5 lumon:gap-x-5 lumon:md:gap-x-3'
);
export const containerNonMobileClasses = 'gap-x-0 sm:gap-x-4 justify-start';
